import { popupManager } from './popup-manager';
import './styles/base.css';

document.addEventListener('DOMContentLoaded', () => {
	const config = window.gfPopupsConfig;
	if (!config?.popups?.length) return;

	popupManager.init(config.popups);

	window.GFPopups = {
		show: (feedId: number) => popupManager.show(feedId),
		hide: (feedId: number) => popupManager.hide(feedId),
		getPopup: (feedId: number) => popupManager.getPopup(feedId),
	};
});
